import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({
    commit
  }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({
    commit
  }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({
    commit
  }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({
    commit
  }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setStatus({
    commit
  }, status) {
    commit(types.SET_STATUS, status)
  },
  setFilterBy({
    commit
  }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  clearDevices({
    commit
  }) {
    commit(types.CLEAR_DEVICES)
  },
  setConnectedDevices({ commit }, devices) {
    commit(types.SET_CONNECTED_DEVICES, devices)
  },
  setCurrentDevice({ commit }, device) {
    commit(types.SET_CURRENT_DEVICE, device)
  },
  async getDevice({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getDevice', () =>
      http.get(`device/GetDevice?id=${id}`)
    )
    commit(types.SET_DEVICE, r.data)
  },
  async getDevices({ commit, dispatch }, searchOptions, id) {
    const r = await startLoading(dispatch, 'getDevices', () =>
      http.get(`device/GetDevicesForListing`, {
        params: searchOptions
      })
    )
    commit(types.SET_DEVICES, r.data)
  },
  async getDevicesByLocation({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getDevicesByLocation', () =>
      http.get(`device/GetDevicesByLocation?assignedTo=${id}`)
    )
    commit(types.SET_DEVICES, r.data)
    return r.data
  },
  async getPairingInfoDevice({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getPairingInfoDevice', () =>
      http.get(`device/GetPairingInfo?id=${id}`)
    )
    commit(types.SET_PAIRING_INFO, r.data)
    return r.data
  },
  async getPairingInfoWorkOrder({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getPairingInfoWorkOrder', () =>
      http.get(`device/GetPairingForServiceRequest?id=${id}`)
    )
    commit(types.SET_WO_PAIRING_INFO, r.data)
    return r.data
  },
  async getPairingInfoDevices({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getPairingInfoDevices', () =>
      http.post(`device/GetPairingInfoDevices`, data)
    )
    return r.data
  },
  async updateDevice({ commit, dispatch }, data) {
    await startLoading(dispatch, 'updateDevice', () =>
      http.get(`device/DispatchToolUpdate`, {
        params: data
      })
    )
  },
  async updateDispatchDevice({ commit, dispatch }, data) {
    if (status.StatusId === 41) {
      status.StatusId = 144
    } else if (status.StatusId === 33) {
      status.StatusId = 146
    } else if (status.StatusId === 142) {
      status.StatusId = 143
    }
    const dispatchUrl = window.config ? window.config.dispatchUrl : ''
    await startLoading(dispatch, 'updateDispatchDevice', () =>
      http.post(`api/posts/UpdateToolStatus/?toolID=${data.id}&statusID=${data.statusId}`, {}, {}, dispatchUrl)
    )
  },
  async getServerProfiles({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getServerProfiles', () =>
      http.get(`device/GetServerProfiles`)
    )
    commit(types.SET_SERVER_PROFILES, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/devices/actions.js